import React from "react";
import { useTranslation } from "react-i18next";
import axiosInstance from "../api/axiosInstance";
import ModifiedForm from "./layout/form/ModifiedForm";
import { TextArea } from "./layout/form/TextInputFields";
import ErrorHandler from "../error-handler/ErrorHandler";

function CreateInstructions() {
  const { t } = useTranslation();

  const submitInstruction = async (data) => {
    try {
      let result = await axiosInstance.post("/instructions", data);
      return { type: 1, message: t("success") };
    } catch (e) {
      console.log(e.response);

      return { type: 2, message: e.response.data };
    }
  };
  return (
    <ModifiedForm submitFunction={submitInstruction}>
      <h4 className="title">{t("createInstruction")}</h4>

      <div className="text-area-form">
        <TextArea
          id="text_ar"
          className="formTextField text-area"
          validation={{ required: true }}
          title={t("ar")}
        />
        <TextArea
          id="text_en"
          className="formTextField text-area"
          validation={{ required: true }}
          title={t("en")}
        />
      </div>
      <div className="formSubmit">
        <button className="defaultButton" type="submit">
          {t("buttons.finish")}
        </button>
      </div>
    </ModifiedForm>
  );
}

export default ErrorHandler(CreateInstructions, axiosInstance);
